import { render, staticRenderFns } from "./synchronize.vue?vue&type=template&id=7407301a&scoped=true&"
import script from "./synchronize.vue?vue&type=script&lang=ts&"
export * from "./synchronize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7407301a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7407301a')) {
      api.createRecord('7407301a', component.options)
    } else {
      api.reload('7407301a', component.options)
    }
    module.hot.accept("./synchronize.vue?vue&type=template&id=7407301a&scoped=true&", function () {
      api.rerender('7407301a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/view/synchronization/synchronize.vue"
export default component.exports